import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ApiCalendar from 'react-google-calendar-api';
  
// "Not a valid origin for the client: http://localhost:3006 has not been whitelisted for client ID 
// 343984817750-oe38lh5pcnh94np4ep9i3omouelelful.apps.googleusercontent.com. 
// Please go to https://console.developers.google.com/ and whitelist this origin for your project's client ID."

const Test = (test) => {


const [events, setEvents] = useState();
  // all keys found on this site https://developers.google.com/calendar/quickstart/js
const gapi = window.gapi;
const PROJECT_NAME = "ZenGTD";

// const CLIENT_ID = '735618644679-17dve6uh8bf63v9gapmboi0e9voirc87.apps.googleusercontent.com';
// const API_KEY = 'AIzaSyD-HxGVcIu6a7NBhZzXv28Sxk7QzDQRKnU';

const CLIENT_ID = '343984817750-oe38lh5pcnh94np4ep9i3omouelelful.apps.googleusercontent.com';
const API_KEY = 'AIzaSyAt2Utlx_oBK2AWDkcErRp0SuK8-T1JJKU';


// Array of API discovery doc URLs for APIs used by the quickstart
const DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"];
const SCOPES = "https://www.googleapis.com/auth/calendar.events";


  const handleItemClick = (event, name) => {
    if (name === 'sign-in') {
      ApiCalendar.handleAuthClick();
    } else if (name === 'sign-out') {
      ApiCalendar.handleSignoutClick();
    }
  }


  const fetchEvents = (howMatch) => {
    if (ApiCalendar.sign)
    {
      ApiCalendar.listUpcomingEvents(howMatch)
        .then(({result}) => {
          console.log('tu',result.items);
          const allEvents = []
          result.items.map((item)=>{
            console.log(item.start.dateTime);
            allEvents.push({summary: item.summary, startDateTime: item.start.dateTime});
          })
          setEvents(allEvents);
        });
    }
  }
  const onClickHandler = () => {
    alert('test');

    gapi.load('client:auth2', () => {
      console.log('loaded client');

      gapi.client.init({
        apiKey: API_KEY,
        clientId: CLIENT_ID,
        discoveryDocs: DISCOVERY_DOCS,
        scope: SCOPES
      });

      gapi.client.load('calendar', 'v3', ()=>console.log('bam!'))

      gapi.auth2.getAuthInstance().then(()=>{
        var event = {
          'summary': 'Google I/O 2015',
          'location': '800 Howard St., San Francisco, CA 94103',
          'description': 'A chance to hear more about Google\'s developer products.',
          'start': {
            'dateTime': '2020-08-23T09:00:00-07:00',
            'timeZone': 'America/Los_Angeles'
          },
          'end': {
            'dateTime': '2020-08-23T17:00:00-07:00',
            'timeZone': 'America/Los_Angeles'
          },
          'recurrence': [
            'RRULE:FREQ=DAILY;COUNT=2'
          ],
          'attendees': [
            {'email': 'lpage@example.com'},
            {'email': 'sbrin@example.com'}
          ],
          'reminders': {
            'useDefault': false,
            'overrides': [
              {'method': 'email', 'minutes': 24 * 60},
              {'method': 'popup', 'minutes': 10}
            ]
          }
        };

        const request = gapi.client.calendar.events.insert({
          'calendarId': 'primary',
          'resource': event,
        })

        request.execute(event => {
            console.log(event);
        })
      });
    })
  }




  console.log('eventy', events);
  return(<>
    <button onClick={(e) => handleItemClick(e, 'sign-in')}>
      sign-in
    </button>
    <button onClick={(e) => handleItemClick(e, 'sign-out')}>
      sign-out
    </button>
    <ul>
    {events && events.map((event)=>{
      return <li>{event.summary }({event.startDateTime})</li>
    })}
    </ul>
    <button onClick={(e)=> onClickHandler()}>laod</button>
    <button onClick={(e)=> fetchEvents()}>fetch events</button>

    </>);
}

const mapStateToProps = (state) => ({
    test: state.test
});

export default connect(
  mapStateToProps,
  null
)(Test);